import { render } from "./ThePatientGeneralAuthorizations.vue?vue&type=template&id=98f8d370&scoped=true&ts=true"
import script from "./ThePatientGeneralAuthorizations.vue?vue&type=script&lang=ts"
export * from "./ThePatientGeneralAuthorizations.vue?vue&type=script&lang=ts"

import "./ThePatientGeneralAuthorizations.vue?vue&type=style&index=0&id=98f8d370&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f8d370"]])

export default __exports__